import { render } from "./RangeInput.vue?vue&type=template&id=0b65b489"
import script from "./RangeInput.vue?vue&type=script&lang=js"
export * from "./RangeInput.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__